import { Injectable } from '@angular/core';
// import { ColorService } from '@app/services/api/color.service';
import { BriefService } from '@app/services/api/brief.service';
import { FlashService } from '@app/services/flash.service';
import {
  BriefActionTypes,
  ChangeStatus,
  ChangeStatusSuccess,
  CreateBrief,
  CreateBriefFail,
  CreateBriefSuccess,
  DownloadBriefFinal,
  DownloadBriefPM,
  ExportBrief,
  ExportInitialBrief,
  GetLink,
  GetLinkFail,
  Load,
  LoadFail,
  LoadInfoModal,
  LoadInfoModalSuccess,
  LoadSuccess,
  UpdateBrief,
  UpdateBriefFail,
  UpdateBriefSuccess,
  UploadFile,
  UploadFileFail
} from '@core/actions/brief.actions';

import { Brief } from '@app/models';
import { ApiService } from '@app/services/api/api.service';
import { WebsocketService } from '@app/services/websocket.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, concatMap, exhaustMap, map, mergeMap, switchMap } from 'rxjs/operators';

@Injectable()
export class BriefEffects {
  _processing = {};
  _timer;

  @Effect()
  load$ = this.actions$.pipe(
    ofType<Load>(BriefActionTypes.Load),
    map(action => action),
    switchMap(id => {
      console.log("ACTIONS DE BRIEFS")
      return this.briefApi.getBriefs().pipe(
        map((briefs: Brief[]) => new LoadSuccess(briefs)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadInfoModal$ = this.actions$.pipe(
    ofType<LoadInfoModal>(BriefActionTypes.LoadInfoModal),
    map(action => action),
    switchMap(id => {
      console.log("ACTIONS LOAD INFO MODAL")
      return this.briefApi.getInfoModalBrief().pipe(
        map((data) => new LoadInfoModalSuccess(data)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  createBrief$ = this.actions$.pipe(
    ofType<CreateBrief>(BriefActionTypes.CreateBrief),
    map(action => [action.data, action.file]),
    switchMap(([data, file]) => {
      return this.briefApi.createBrief(data).pipe(
        map((response: any) => new GetLink({BriefInitialId: response.id}, file, true, response, false)),
        catchError(error => of(new CreateBriefFail(error)))
      );
    })
  );

  @Effect()
  updateBrief$ = this.actions$.pipe(
    ofType<UpdateBrief>(BriefActionTypes.UpdateBrief),
    map(action => [action.id, action.data]),
    switchMap(([id, data]) => {
      console.log("ACTION UPDATE ID", id)
      console.log("ACTION UPDATE DATA", data)
      return this.briefApi.updateBrief(id, data).pipe(
        map((data) => new UpdateBriefSuccess(data)),
        catchError(error => of(new UpdateBriefFail(error)))
      );
    })
  );

  @Effect({ dispatch: false })
  exportBrief$ = this.actions$.pipe(
    ofType<ExportBrief>(BriefActionTypes.ExportBrief),
    map(action => {
      return this.briefApi.exportBrief(action.id, action.fileName)
    })
  );

  @Effect({ dispatch: false })
  downloadBriefPM$ = this.actions$.pipe(
    ofType<DownloadBriefPM>(BriefActionTypes.DownloadBriefPM),
    map(action => {
      return this.briefApi.downloadBriefPM(action.id, action.fileName)
    })
  );

  @Effect({ dispatch: false })
  downloadBriefFinal$ = this.actions$.pipe(
    ofType<DownloadBriefFinal>(BriefActionTypes.DownloadBriefFinal),
    map(action => {
      return this.briefApi.downloadBriefFinal(action.id, action.fileName)
    })
  );

  @Effect({ dispatch: false })
  exportInitialBrief$ = this.actions$.pipe(
    ofType<ExportInitialBrief>(BriefActionTypes.ExportInitialBrief),
    map(action => {
      return this.briefApi.exportInitialBrief()
    })
  );

  
  @Effect()
  getLink$ = this.actions$.pipe(
    ofType<GetLink>(BriefActionTypes.GetLink),
    map(action => [action.owner, action.file, action.featured, action.data, action.isConfirmation]),
    exhaustMap(([owner, file, featured, data, isConfirmation]) =>
      this.api.getFileUploadLink(owner, file, featured).pipe(
        concatMap((link: any) => {
          return [new UploadFile(link, file, data, isConfirmation)];
        }),
        catchError(error => of(new GetLinkFail(error)))
      )
    )
  );

  @Effect()
  uploadFile$ = this.actions$.pipe(
    ofType<UploadFile>(BriefActionTypes.UploadFile),
    map(action => [action.link, action.file, action.data, action.isConfirmation]),
    exhaustMap(([link, file, data, isConfirmation]: [any, any, any, any]) => {
      const url = link.signedUrl;
      const fileId = link.id;
      console.log("URL ->", url)
      return this.api.uploadFile(url, file).pipe(
        mergeMap(response => {
          console.log("DATA EFFECT FINAL ->", data)
            return isConfirmation
            ? of(new ChangeStatus(data) as CreateBriefSuccess | ChangeStatus)
            : of(new CreateBriefSuccess(data) as CreateBriefSuccess | ChangeStatus)
        }),
        catchError(error => of(new UploadFileFail(error)))
      );
    })
  );

  @Effect()
  changeStatus$ = this.actions$.pipe(
    ofType<ChangeStatus>(BriefActionTypes.ChangeStatus),
    map(action => [action.data]),
    exhaustMap(([data]: [any]) => {
      console.log("CHANGE STATUS EFFECT =>", data)
      return this.briefApi.changeStatus(data.briefId, data).pipe(
        concatMap(response => {
          console.log("RESPONSE EFFECT CHANGE STATUS->", response)
          return [new ChangeStatusSuccess(response)];
        }),
        catchError(error => {
          return of(new UploadFileFail(error));
        })
      );
    })
  );

  constructor(
    private actions$: Actions,
    private briefApi: BriefService,
    private fs: FlashService,
    private api: ApiService,
    private ws: WebsocketService,
    private store: Store<any>
  ) {}
}
